import {useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import useCurrentUser from '../../hooks/useCurrentUser'

import {
	removeRecipe,
	updateViewer,
	selectRecipeById,
} from './recipesSlice'

import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import css from './Recipes.module.css'

import MacroTotals from './MacroTotals'

import {ellipsis} from '../../util/util'

import {useHistory} from 'react-router-dom'

const Food = ({food,quantity,position,optional,id,idx,recipeId})=>{

	//destructure macros per unit
	const {calories,protein,fat,carbs} = food

	return (
		<div className="py-1 px-3 rounded border mb-2">
			<div>
				<div>
					<div>
						<small><strong>{food.food_db_name}</strong> {Boolean(optional)&&(optional)}</small>
					</div>
					<div className="d-flex justify-content-between">
						<small className="text-muted">
							{food.portion_unit!=='not specified'&&`Qty: ${(quantity*food.portion_size).toFixed(1)} ${food.portion_unit} `}
						</small>
					</div>
				</div>
			</div>
		</div>
	)
}

const Viewer = ()=>{
	const history = useHistory()
	const dispatch = useDispatch()
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'

	const [expandImage,setExpandImage] = useState(false)

	const {show,id} = useSelector(
		state => state.recipes.viewer
	)

	const recipe = useSelector(
		state => selectRecipeById(state,id)
	)

	const handleClose = ()=>{
		setExpandImage(false)
		dispatch(
			updateViewer({
				show:false,
				id:null
			})
		)
	}

	const isDeleteLoading = false

	const handleEditRecipe = ()=>{
		history.push(`/recipe-editor?id=${id}`)
	}

	const handleDeleteRecipe = ()=>{
		if (!window.confirm('Are you sure you want to delete this recipe?')) return
		dispatch(removeRecipe({recipe_id:id}))
		dispatch(updateViewer({show:false,id:null}))
	}

	if (!recipe) return null

	return (
		<Modal show={show} onHide={handleClose} size={expandImage?"lg":'md'}>
			<Modal.Header >
				<Modal.Title className="text-center col-12">
					<button onClick={handleClose} type='button' className="close float-right px-0" data-dismiss='modal' aria-label='Close'>
						<span aria-hidden='true'>&times;</span>
					</button>
					{recipe.name}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="mt-2">
				<div className="row" style={{ display: "block" }}>
					<small className="d-block text-center">
						{expandImage
							? 'Click the image again to go back'
							: 'Click the image to zoom in'
						}
					</small>
					<div className=" col-sm-12 d-flex justify-content-center">
						{recipe.image &&
							<img 
								onClick={()=>{
									setExpandImage(p=>!p)
								}}
								src={recipe.image} 
								alt="Recipe example" 
								style={{ 
									width: expandImage?'100%':"300px",
									maxWidth: expandImage?'100%':"300px",
									borderRadius: '7px',
									cursor:expandImage?'zoom-out':'zoom-in'
								}} 
							/>
						}
					</div>
					{!expandImage&&
						<div className=" col-sm-12">
							{recipe.description && <p className="text-center mx-4">
								{recipe.description}
							</p>}
							<div className="d-flex justify-content-around w-100 mt-1">
								{recipe?.serving_size?.length > 0 &&
									<div>
										<span><strong> Serving Size: </strong></span> {recipe.serving_size}
									</div>}
								{recipe?.num_servings?.length > 0 &&
									<div>
										<span> <strong> Number of Servings:</strong></span> {recipe.num_servings}
									</div>
								}
							</div>
							<hr />
							<p style={{ whiteSpace: "pre-line" }}><span className={css.BoldText}>Toppings or Add Ins (optional)</span> {recipe.add_ins || "None"}</p>
							<p style={{ whiteSpace: "pre-line" }}><span className={css.BoldText}>Directions</span> {recipe.directions}</p>
							{(recipe.foods.length > 0 || Boolean(recipe.ingredients)) && 
								<div>
									<strong className={css.BoldText}>Ingredients</strong>
								</div>
							}
							{Boolean(recipe.ingredients) && 
								<div className="d-block" style={{whiteSpace:'pre-line'}}>{recipe.ingredients}</div>
							}
							{(recipe.foods.length > 0) && 
								<div>
									{recipe.foods.map(recipeFood=>(
										<Food {...recipeFood}/>
									))}
								</div>
							}
							<MacroTotals recipe={recipe} />
							{recipe.tags?.length > 0 && <p className={css.BoldText}> Tags  </p>}
							<p style={{ display: "flex", flexWrap: "wrap" }}>
								{recipe.tags?.length > 0 && recipe.tags.map(
									(tag) =>
										<span className={css.ModalMacros}>
											<span>{tag.name}</span>
										</span>
								)}
							</p>
							{recipe.link && <p><span className={css.BoldText} style={{ display: "inline" }}>Link: </span> <a target="_blank" href={recipe.link}> {recipe.link}</a></p>}
						</div>
					}
				</div>
			</Modal.Body>
			{(recipe.owner_type === user.account_type) &&
				<Modal.Footer>
					<Button 
						disabled={isDeleteLoading} 
						className={`btn btn-outline-primary ${css.editButton}`} 
						style={{ backgroundColor: "white" }} 
						onClick={() => handleEditRecipe(recipe)}
					>
							<i className="fa fa-edit"></i>
					</Button>
					<Button 
						disabled={isDeleteLoading} 
						variant="outline-danger" 
						style={{ marginLeft: "10px", float: "right" }} 
						onClick={() => handleDeleteRecipe(recipe.id)}
					>
						{isDeleteLoading ?
							<Spinner animation="border" size="sm" role="status">
								<span className="sr-only">deleting</span>
							</Spinner> :
							<i className="fa fa-trash"></i>}</Button>
				</Modal.Footer>
			}
			{(recipe.owner_type !== user.account_type&&recipe.owner_type==='MAX')&&
				<Modal.Footer>
					<small>This is a MAX corporate recipe and can only be edited by the MAX corporate account</small>
				</Modal.Footer>
			}
		</Modal>
	)
}

export default Viewer 